import New from './IntegrationPartnerNew'
import Main from './IntegrationPartnerMain'
import Edit from './IntegrationPartnerEdit'

const IntegrationPartner = {
  New,
  Main,
  Edit,
}

export default IntegrationPartner
